var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9967 8.99984C10.9967 8.44784 11.4447 7.99984 11.9967 7.99984C12.5487 7.99984 12.9967 8.44784 12.9967 8.99984V12.9998C12.9967 13.5518 12.5487 13.9998 11.9967 13.9998C11.4447 13.9998 10.9967 13.5518 10.9967 12.9998V8.99984ZM10.9967 15.9998C10.9967 15.4478 11.4447 14.9998 11.9967 14.9998C12.5487 14.9998 12.9967 15.4478 12.9967 15.9998C12.9967 16.5518 12.5487 16.9998 11.9967 16.9998C11.4447 16.9998 10.9967 16.5518 10.9967 15.9998ZM20.8616 18.3528C20.6326 18.7578 20.1866 18.9998 19.6686 18.9998H4.32455C3.80655 18.9998 3.36055 18.7578 3.13255 18.3528C3.02455 18.1628 2.88255 17.7758 3.14955 17.3358L10.8206 4.61781C11.2876 3.84381 12.7056 3.84381 13.1726 4.61781L20.8446 17.3358C21.1106 17.7758 20.9696 18.1628 20.8616 18.3528ZM22.5583 16.3028L14.8863 3.58376C14.2873 2.59176 13.2073 1.99976 11.9973 1.99976C10.7873 1.99976 9.70726 2.59176 9.10926 3.58376L1.43726 16.3028C0.868257 17.2458 0.851257 18.3798 1.39126 19.3358C1.97026 20.3628 3.09526 20.9998 4.32526 20.9998H19.6693C20.9003 20.9998 22.0243 20.3628 22.6043 19.3358C23.1443 18.3798 23.1273 17.2458 22.5583 16.3028Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/AlertTriangle.f71bae0b057ac7efae2f71f4e8281f8a.svg";
export { ForwardRef as ReactComponent };